export const ORDER_WISE_REVENUE_EXPORT_COLUMNS = [
  { header: 'Order Number', key: 'order_number', type: 'text' },
  { header: 'Status', key: 'status', type: 'text' },
  { header: 'Completed At (IST)', key: 'completed_at_ist', type: 'date' },
  { header: 'Investor', key: 'investor_name', type: 'text' },
  { header: 'Partner', key: 'partner_name', type: 'text' },
  { header: 'RM', key: 'rm_name', type: 'text' },
  { header: 'RM Entity', key: 'rm_entity_code', type: 'text' },
  { header: 'MIS Bucket', key: 'mis_bucket', type: 'text' },
  { header: 'Altcase Price', key: 'altcase_price', type: 'number' },
  { header: 'Partner Slab', key: 'price_partner', type: 'number' },
  { header: 'Partner Sell', key: 'partner_sell_price', type: 'number' },
  { header: 'Fulfilled Price', key: 'fulfilled_price', type: 'number' },
  { header: 'Unit Price', key: 'unit_price', type: 'number' },
  { header: 'RM Price', key: 'rm_price', type: 'number' },
  { header: 'Quantity', key: 'quantity', type: 'number' },
  { header: 'Fulfilled Qty', key: 'fulfilled_quantity', type: 'number' },
  { header: 'Is B2C', key: 'is_b2c', type: 'text' },
  { header: 'Platform Margin', key: 'platform_margin', type: 'number' },
  { header: 'RM Net', key: 'rm_net', type: 'number' },
  { header: 'Central Uplift', key: 'central_uplift', type: 'number' },
  { header: 'Central Gross Uplift', key: 'central_gross_uplift', type: 'number' },
  { header: 'Channel Revenue', key: 'channel_revenue', type: 'number' },
];

export function mapOrderWiseRevenueExportRow(row) {
  return {
    order_number: row.order_number ?? '',
    status: row.status ?? '',
    completed_at_ist: row.completed_at_ist ?? '',
    investor_name: row.investor_name ?? '',
    partner_name: row.partner_name ?? '',
    rm_name: row.rm_name ?? '',
    rm_entity_code: row.rm_entity_code ?? '',
    mis_bucket: row.mis_bucket ?? '',
    altcase_price: Number(row.altcase_price) || 0,
    price_partner: Number(row.price_partner) || 0,
    partner_sell_price: Number(row.partner_sell_price) || 0,
    fulfilled_price: Number(row.fulfilled_price) || 0,
    unit_price: Number(row.unit_price) || 0,
    rm_price: row.rm_price == null || row.rm_price === '' ? null : Number(row.rm_price),
    quantity: Number(row.quantity) || 0,
    fulfilled_quantity: Number(row.fulfilled_quantity) || 0,
    is_b2c: row.is_b2c ? 'Yes' : 'No',
    platform_margin: Number(row.platform_margin) || 0,
    // Blank for Central Team / B2C — API sends null when not a named SALES bucket
    rm_net: row.rm_net == null || row.rm_net === '' ? null : Number(row.rm_net),
    central_uplift: Number(row.central_uplift) || 0,
    central_gross_uplift: Number(row.central_gross_uplift) || 0,
    channel_revenue: Number(row.channel_revenue) || 0,
  };
}
